module.exports = __webpack_public_path__ + "img/lk.96cf4c4.svg";